import { render, staticRenderFns } from "./admin-sidebar.vue?vue&type=template&id=73a9c69e&"
import script from "./admin-sidebar.vue?vue&type=script&lang=js&"
export * from "./admin-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports